<style lang="scss">
.choose-exam-region {
  margin-top: 19px;
  padding: 10px 0;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.2);
  @media (min-width: 992px) {
    padding: 30px 50px;
  }
  @media (min-width: 1200px) {
    padding: 30px 70px;
  }
  .subject {
    width: 600px;
    margin: 0 auto;
  }
  .region {
    margin: 44px auto;
    width: 480px;
    @media screen and (max-width: 768px) {
      margin: 20px auto;
      width: 100%;
    }
    .bar {
      margin-top: 10px;
      border-bottom: 1px solid #cccccc;
      div {
        height: 27px;
        width: 70px;
        font-size: 14px;
        text-align: center;
        line-height: 27px;
        display: inline-block;
        cursor: pointer;
        color: #999999;
        margin-bottom: -2px;
      }
      .active {
        background: white;
        color: #000000;
        border: 1px solid #cccccc;
        border-bottom: 1px solid transparent;
      }
    }
    .chose-box {
      min-height: 115px;
      margin-top: 10px;
      .block {
        margin-right: 8px;
        cursor: pointer;
        float: left;
        width: 112px;
        margin-top: 12px;
        text-align: center;
      }
    }
  }
  .steps {
    margin: 44px auto;
    width: 280px;
  }
  .line {
    border-top: 3px solid #cccccc;
    width: 30px;
    margin: 8px 18px;
  }
  .Choosed {
    margin: 50px auto;
    width: 400px;
    cursor: pointer;
    @media screen and (max-width: 768px) {
      margin: 20px auto;
      width: 100%;
    }
    .region {
      padding-left: 20px;
    }
  }
  .btn-box {
    margin-top: 30px;
    text-align: center;
  }
  .tip-box {
    margin: 20px 0;
  }
}
</style>
<template>
  <div>
    <div class="choose-exam-region">
      <exam-reg-menu menuIndex="3"></exam-reg-menu>
      <div class="steps">
        <div class="float-left">① 科目选择</div>
        <div class="float-left line"></div>
        <div class="float-left AEE-tc">② 考区选择</div>
      </div>
      <div class="clear"></div>
      <div class="tip-box" v-html="tip"></div>
      <div v-if="subjectRegionList.length>0" v-for="item in subjectRegionList">
        <div class="subject">{{item.subject_name}}:</div>
        <div class="region" v-show="item.listShow">
          <section class="bar">
            <div
              class="area"
              v-for="v in item.examRegionGrades"
              @click="SelectedTitle(item,v)"
              v-show="v.showChose"
              :class="v.chooseRegion?'':'active'"
            >{{v.chooseRegion ? v.chooseRegion : '请选择'}}</div>
          </section>
          <ul class="chose-box">
            <li v-for="v in item.examRegionGrades" v-show="v.showRegionList">
              <span
                v-for="(n,k) in v.chooseRegionList"
                @click="getRegionGradesId(item,v.index,n, k)"
                class="block"
              >{{n.value}}</span>
            </li>
          </ul>
          <div class="clear"></div>
        </div>
        <div
          class="Choosed"
          v-show="!item.listShow"
          @click="regChoose(item)"
          :style="item.examRegionGrades.length<5?'':'width:600px;'"
        >
          <span>当前选择考区：</span>
          <span v-for="v in item.examRegionGrades" class="region">{{v.chooseRegion}}</span>
          <i class="el-icon-caret-bottom" style="color: #999999"></i>
        </div>
      </div>
      <div class="btn-box">
        <el-button class="btn-agree" @click="preStep()" type="primary">上一步</el-button>
        <el-button class="btn-agree" @click="nextStep()" type="primary" :disabled="btnDisable">下一步</el-button>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import m1_examRegMenu from "@components/examRegMenu/m1_examRegMenu";
export default {
  components: {
    'examRegMenu': m1_examRegMenu
  },
  data() {
    return {
      tip: "",
      subjectRegionList: [],
      btnDisable: false
    };
  },
  methods: {
    getData: function() {
      let examRegInfo = this.$store.state.examRegInfo.examRegInfo,
        list = [];
      if (examRegInfo === null) {
        this.$router.push({ name: "default.examReg.chooseBatch" });
      }
      examRegInfo.region_subject_selections.subjects.forEach(item => {
        list.push(item.subject_id);
      });

      this.$http
        .post(globalProvider.serviceUrl("e_reg/g/ras"), {
          subject_ids: list
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            if (data.body.data.length > 0) {
              data.body.data.forEach((item, index) => {
                item.examRegionGrades = [
                  {
                    index: 1,
                    RegionId: null,
                    showChose: true,
                    chooseRegion: false,
                    showRegionList: true,
                    chooseRegionList: item.regions
                  }
                ];
                item.listShow = true;
                this.subjectRegionList.push(item);
                //                                    if (examRegInfo.region_subject_selections.subjects[index].region_id) {
                //                                        this.setChosedRegion(examRegInfo.region_subject_selections.subjects(index).path,this.subjectRegionList[index])
                //                                    }
              });
              //获取已提交的区域
              this.getRegModel(
                this.$store.state.examRegInfo.examRegInfo.exam_registration_id,
                this.subjectRegionList
              );
            } else {
              this.$router.push({ name: "default.examReg.chooseBatch" });
            }
          }
        });
    },
    SelectedTitle: function(subject, item) {
      item.chooseRegion = false;
      item.showRegionList = true;
      subject.examRegionGrades.splice(
        item.index,
        subject.examRegionGrades.length - item.index
      );
    },
    //获取页面提示信息
    getTip: function() {
      this.$http.get(globalProvider.serviceUrl("e_reg/g/sts/{key_code}"), {
          params: { key_code: tipKeyCode.region_reg_success }
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            if (data.body.data != null) {
              this.tip = data.body.data.key_value;
            }
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    //            setChosedRegion: function (data,item) {
    //                console.log(data)
    //                let i, j;
    //                for (i of data) {
    //                    let index = data.indexOf(i),
    //                        thisGrade = item.examRegionGrades[index],
    //                        num = 0;
    //                    for (j of item.examRegionGrades[index].chooseRegionList) {
    //                        if (j.label == i) {
    //                            thisGrade.chooseRegion = j.value;
    //                            thisGrade.RegionId = j.label;
    //                            if (j.children.length > 0) {
    //                                thisGrade.showRegionList = false;
    //                                item.examRegionGrades.push({
    //                                    index: index + 2,
    //                                    showChose: true,
    //                                    chooseRegion: false,
    //                                    showRegionList: true,
    //                                    chooseRegionList: j.children
    //                                })
    //                            }
    //                        }
    //                        else {
    //                            num++
    //                        }
    //                    }
    //                    if (num === item.examRegionGrades[index].chooseRegionList.length) {
    //                        item.listShow = true;
    //                        break;
    //                    }
    //                    if (typeof(item.examRegionGrades[index + 1]) !== "undefined") {
    //                        if (item.examRegionGrades[index + 1].chooseRegionList.length > 0 && data.length < index + 2) {
    //                            item.listShow = true;
    //                        }
    //                    }
    //                }
    //            },
    getRegionGradesId: function(subject, grade, item, index) {
      if (item.children.length == 0) {
        subject.examRegionGrades[grade - 1].chooseRegion = item.value;
        subject.examRegionGrades[grade - 1].RegionId = item.label;
        subject.listShow = false;
        let path = [];
        subject.examRegionGrades.forEach(item => {
          path.push(item.RegionId);
        });
        subject.field = {
          region_id: item.label,
          region_name: item.value,
          path: path
        };
      } else {
        let thisGrade = subject.examRegionGrades[grade - 1];
        let nextGrade = {
          index: grade + 1,
          showChose: true,
          chooseRegion: false,
          showRegionList: true,
          chooseRegionList: []
        };
        thisGrade.chooseRegion = item.value;
        thisGrade.RegionId = item.label;
        thisGrade.showRegionList = false;
        nextGrade.chooseRegionList = thisGrade.chooseRegionList[index].children;
        subject.examRegionGrades.push(nextGrade);
      }
    },
    regChoose: function(subject) {
      subject.listShow = true;
      subject.field = "";
      subject.examRegionGrades[
        subject.examRegionGrades.length - 1
      ].chooseRegion = false;
    },
    preStep: function() {
      this.$router.push({ name: "default.examReg.chooseSubject2" });
    },
    nextStep: function() {
      this.btnDisable = true;
      let examRegInfo = this.$store.state.examRegInfo.examRegInfo,
        state = true,
        list = [];
      this.subjectRegionList.forEach(item => {
        if (!item.field) {
          state = false;
        } else {
          list.push({
            subject_id: item.subject_id,
            region_id: item.field.region_id
          });
        }
      });
      if (state) {
        this.$http
          .post(globalProvider.serviceUrl("e_reg/u/rsrsi"), {
            eri: examRegInfo.exam_registration_id,
            subject_regions: list
          })
          .then(data => {
            this.btnDisable = false;
            if (data.body.code === resultCode.Success) {
              this.$store.commit("setExamRegInfoItem", {
                region_subject_selections: this.field
              });
              this.$router.push({ name: "default.examReg.submitRegInfo" });
            } else if (data.body.code == resultCode.NotSuccess) {
              this.$alert(getErrorMessage(data.body.message));
            }
          });
      } else {
        this.btnDisable = false;
        this.$alert("请完成所有科目的区域选择", { confirmButtonText: "确定" });
      }
    },
    //获取提交的报考信息
    getRegModel: function(reg_id, subjectRegionList) {
      let reg_info_operation = 1;
      this.$http
        .get(
          globalProvider.serviceUrl(
            "e_reg/g/eri/{reg_id}/{reg_info_operation}"
          ),
          {
            params: {
              reg_id: reg_id,
              reg_info_operation: reg_info_operation
            }
          }
        )
        .then(data => {
          if (data.body.code === resultCode.Success) {
            if (data.body.data.region_subject_selections) {
              let subject_id_list =
                data.body.data.region_subject_selections.subjects;
              subjectRegionList.forEach(item => {
                subject_id_list.forEach(sub => {
                  if (sub.subject_id == item.subject_id) {
                    item.examRegionGrades.forEach(v => {
                      v.chooseRegionList.forEach((n, k) => {
                        if (n.label == sub.region_id) {
                          this.SelectedTitle(item, v);
                          this.getRegionGradesId(item, v.index, n, k);
                        }
                      });
                    });
                  }
                });
              });
            }
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    }
  },
  created: function() {
    this.$store.commit("setHeaderState", "3");
    this.getData();
    this.getTip();
  }
};
</script>